import * as React from "react";
const SvgFiRrKazoo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-kazoo_svg__a)">
      <path d="M12 13h-1v-1a1 1 0 1 0-2 0v1H8a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2" />
      <path d="M23.157 1.542 22.46.843A3.02 3.02 0 0 0 18.644.49l-7.52 5.407a1 1 0 0 0-.124.105L8.893 8.108a6.01 6.01 0 0 0-4.787 4.788l-2.9 2.9a3.97 3.97 0 0 0-1.172 2.829 3.97 3.97 0 0 0 1.172 2.828l1.414 1.413a3.97 3.97 0 0 0 2.828 1.172 3.98 3.98 0 0 0 2.83-1.172l3.004-3.004a6.01 6.01 0 0 0 4.574-4.574l2.213-2.213a1 1 0 0 0 .111-.132l5.35-7.613a3.006 3.006 0 0 0-.375-3.785zM6.864 21.451a2 2 0 0 1-2.829 0l-1.414-1.415a1.99 1.99 0 0 1-.586-1.414c0-.534.208-1.037.586-1.415l1.603-1.603a6.01 6.01 0 0 0 4.285 4.201zM10 18c-2.206 0-4-1.795-4-4s1.794-4 4-4 4 1.793 4 4c0 2.205-1.794 4-4 4M21.881 4.196l-5.285 7.522-.79.79a6.01 6.01 0 0 0-4.202-4.285l.753-.753 7.426-5.339a1 1 0 0 1 1.262.124l.698.7a.996.996 0 0 1 .14 1.24z" />
    </g>
    <defs>
      <clipPath id="fi-rr-kazoo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKazoo;
